module.exports = __webpack_public_path__ + "assets/images/fc7f075a10657e0bd9fc4792a92f2dd4.jpg";